import React from 'react'
import { Resume } from 'packages/types'
import { SettingsFieldChangeHandler } from '../../../../../modules/resumeEditor'
import { useTemplateCustomization } from './useTemplateCustomization'

const MAP_FIELD_NAME_TO_SETTINGS_FIELD = {
  headerAlignment: 'supportsHeaderAlignmentCustomization',
  dateAlignment: 'supportsDateAlignmentCustomization',
  locationAlignment: 'supportsLocationAlignmentCustomization',
} as const

export function useLayoutAlignmentCustomisation(
  fieldName: 'headerAlignment' | 'dateAlignment' | 'locationAlignment',
  resume: Resume,
  onFieldChange?: SettingsFieldChangeHandler,
) {
  const { currentTemplate, resumeSpecificTemplateSettings } = useTemplateCustomization(resume)
  const defaultSettings = currentTemplate?.settings
  const currentSettings = resumeSpecificTemplateSettings

  const supportsField = MAP_FIELD_NAME_TO_SETTINGS_FIELD[fieldName]

  return {
    value: currentSettings?.[fieldName] || defaultSettings?.[fieldName],
    isDisabled: !currentTemplate?.[supportsField],
    onSelect: (event: React.ChangeEvent<HTMLInputElement>) => {
      const name = event.target.name as keyof typeof resumeSpecificTemplateSettings
      const newValue = event.target.value
      const oldValue = currentSettings?.[fieldName]
      onFieldChange?.(name, newValue, oldValue)
    },
  }
}
